/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { useEffect } from 'react'
import ApexCharts from 'apexcharts'

interface iChartProps{
  id: string
  aderentes: number
  aderentesResalva: number
  naoAderentes: number
  onChoiceAderencia: (item: number) => void
}

export const PieChart: React.FC<iChartProps> = ({ id, aderentes, aderentesResalva, naoAderentes, onChoiceAderencia }) => {
  function GerarGrafico(): void {
    const options = {
      series: [aderentes, aderentesResalva, naoAderentes],
      labels: ['Aderentes', 'Aderentes com ressalvas', 'Não aderentes'],
      colors: ['#27AE60', '#FFBF2A', '#EB5757'],
      chart: {
        type: 'pie',
        height: 240,
        width: 240,
        events: {
          dataPointSelection: function(chartContext: any, seriesIndex: any, opts: any) {
            onChoiceAderencia(opts.dataPointIndex)
          }
        }
      },
      legend: {
        enabled: false,
        show: false
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (_val: number, opts: any) {
          return opts.w.config.series[opts.seriesIndex]
        },
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          colors: ['#fff']
        }
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: false // DESATIVA o texto no meio
            }
          }
        }
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [aderentes, naoAderentes, aderentesResalva])

  return (
        <div id={id}></div>
  )
}
